import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";

import Confirm from "../../components/Confirm";
import TransactionItem from "./TransactionItem";

import { getTransactions } from "../../api/orders";

const TransactionsBankTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(1);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    (async () => {
      let transactions = await getTransactions();
      setTransactions(transactions);
    })();
  }, [refresh]);

  return (
    <>
      <h2>{t("transactions_bank.title")}</h2>
      <TableComponent
        header={[
          { title: t("id"), sort: "id", style: { width: "5%" } },
          { title: t("company"), sort: "company" },
          { title: t("transactions_bank.similarity_company"), sort: "similarity_company" },
          { title: t("price"), sort: "price", style: { width: "10%" } },

          { title: t("transactions_bank.info"), sort: "tranaction_info" },
          { title: t("transactions_bank.booking_date") },
          { title: t("transactions_bank.validity_date") },
          { title: t("transactions_bank.reference") },
          { title: t("transactions_bank.matched") },
          { title: t("actions") },
        ]}
        renderChildren={(transaction) => <TransactionItem key={transaction.id} transaction={transaction} />}
        items={transactions}
        search={["company", "price", "tranaction_info"]}
        pagination
      />
    </>
  );
};

export default TransactionsBankTable;
